import { createSelector } from 'reselect';

export const getMediaIdList = state => state.getIn(['media', 'mediaIdList']);
export const getMedias = state => state.getIn(['media', 'medias']);

export const getCurrentMedia = state => state.getIn(['news', 'currentMedia']);